export default {
  "import.title": "Uvoz podatkov",
  "import.description": "Uvoz podatkov različnih tipov iz CSV datoteke",

  "import.download-template-file": "Prenesi predlogo CSV datoteke",
  "import.download-template-fileTXT": "Prenesi predlogo TXT datoteke",

  "import.type-not-selected": "Tip uvoza ni izbran",

  "import.buttonLabel": "Uvozi CSV",
  "import.modalTitle": "Uvoz CSV",
  "import.selector.label": "Tip uvoza",

  "import.import.fallbackError": "Uvoz iz CSV ni uspel",
  "import.import.errorTitle": "Napake pri uvozu",

  "import.notification.success":
    "Podatki so bili uspešno uvoženi. Število uvoženih zapisov: {{count}}.",
  "import.notification.success-no-records":
    "Uvoz je bil uspešen, vendar ni bilo uvoženih zapisov.",

  "import.summary.title": "Povzetek uvoza",
  "import.summary.nonBlankRows": "Neprazne vrstice",
  "import.summary.headerRows": "Glava",
  "import.summary.commentRows": "Komentarji (#)",
  "import.summary.dataRows": "Podatkovne vrstice",
  "import.summary.successCount": "Uspešno uvoženo",
  "import.summary.errorRowCount": "Vrstice z napako",
  "import.summary.errorCount": "Napak skupaj",
  "import.summary.warning": "Opozorilo",
  "import.summary.mismatchWarning":
    "Število podatkovnih vrstic ({{dataRows}}) se ne ujema z vsoto uspešnih + napačnih ({{processedKnown}}).",
  "import.summary.nonBlankVsSuccessWarning":
    "Informativno: neprazne vrstice ({{nonBlankRows}}) niso enake številu uspešno uvoženih ({{successCount}}). To je običajno, če datoteka vsebuje glavo, komentarje ali vrstice z napako.",
  "import.summary.headerProcessedHint":
    "Videti je, da je bila glava CSV obdelana kot podatki (npr. 'species'). Preveri skip-header / parser nastavitev za ta endpoint.",

  "import.errors.title": "Napake po vrsticah",
  "import.errors.insufficientFields":
    "Vrstica {{row}}: premalo stolpcev (pričakovano najmanj {{expected}}, prejeto {{actual}}).",
  "import.errors.fieldRequired":
    'Vrstica {{row}}: polje "{{field}}" je obvezno.',
  "import.errors.animalNotFoundByEarTag":
    'Vrstica {{row}}: žival ({{species}}) z ušesno številko "{{usesnaStevilka}}" ne obstaja.',
  "import.errors.fieldDigitsExact":
    'Vrstica {{row}}: polje "{{field}}" mora imeti točno {{digits}} števk (prejeto: {{value}}).',
  "import.errors.fieldDateFormat":
    'Vrstica {{row}}: polje "{{field}}" mora biti v formatu dd.MM.yyyy (prejeto: {{value}}).',
  "import.errors.fieldNumber":
    'Vrstica {{row}}: polje "{{field}}" mora biti število (prejeto: {{value}}).',
  "import.errors.usesnaStevilkaExists":
    'Vrstica {{row}}: ušesna številka "{{usesnaStevilka}}" že obstaja.',
  "import.errors.invalidFilePayload": "Neveljavna datoteka.",

  "import.preview.title": "Predogled CSV (z oznakami vrstic)",
  "import.debug.title": "Napaka strežnika (raw)",

  "import.diagnostics.title": "Napake pri uvozu",
  "import.diagnostics.localCheckTitle": "Lokalni pregled CSV",
  "import.diagnostics.serverErrorsTitle": "Napake iz strežnika",
  "import.diagnostics.rowLabel": "Vrstica {{row}}",
  "import.diagnostics.generalError": "Splošna napaka",
  "import.diagnostics.showMore": "Prikaži še {{count}} vrstic napak",

  "import.precheck.tooManyColumns":
    "Preveč stolpcev ({{actual}}), pričakovano {{expected}}. Možen dodaten ';' ali zamaknjen zapis.",
  "import.precheck.tooFewColumns":
    "Premalo stolpcev ({{actual}}), pričakovano {{expected}}. Manjka vrednost ali separator ';'.",
  "import.precheck.headerMismatch":
    "Glava stolpca #{{index}} je '{{actual}}', pričakovano '{{expected}}'.",
  "import.precheck.headerMissing":
    "Glava CSV ni prepoznana. Preveri, ali prva vrstica vsebuje imena stolpcev.",

  unknownError: "Neznana napaka",

  "import.type.dog.analize.genomSnp": "Analize - genom SNP",
  "import.type.dog.analize.genomSnp.description":
    "Uvoz rezultatov genom SNP analize.",

  "import.type.dog.analize.genotipizacija": "Analize - genotipizacija",
  "import.type.dog.analize.genotipizacija.description":
    "Uvoz podatkov genotipizacije.",

  "import.type.dog.analize.labPosiljka": "Analize - laboratorijska pošiljka",
  "import.type.dog.analize.labPosiljka.description":
    "Uvoz evidenc laboratorijskih pošiljk.",

  "import.type.dog.izlocitev.izlocitev": "Izločitev",
  "import.type.dog.izlocitev.izlocitev.description": "Uvoz dogodkov izločitve.",

  "import.type.dog.kotitve.kotitev": "Kotitve - kotitev",
  "import.type.dog.kotitve.kotitev.description": "Uvoz dogodkov kotitve.",

  "import.type.dog.kotitve.prasitev": "Kotitve - abortusi (prasitev)",
  "import.type.dog.kotitve.prasitev.description":
    "Uvoz abortusov pri prasitvi.",

  "import.type.dog.meritve.drob.dolocitevKakovostnegaRazreda":
    "Meritve (drob) - določitev kakovostnega razreda",
  "import.type.dog.meritve.drob.dolocitevKakovostnegaRazreda.description":
    "Uvoz določitev kakovostnega razreda (drob).",

  "import.type.dog.meritve.drob.misicaHrbet": "Meritve (drob) - hrbtna mišica",
  "import.type.dog.meritve.drob.misicaHrbet.description":
    "Uvoz meritev hrbtne mišice (drob).",

  "import.type.dog.meritve.drob.telesnaOcena": "Meritve (drob) - telesna ocena",
  "import.type.dog.meritve.drob.telesnaOcena.description":
    "Uvoz telesnih ocen (drob).",

  "import.type.dog.meritve.drob.volna": "Meritve (drob) - volna",
  "import.type.dog.meritve.drob.volna.description":
    "Uvoz podatkov volne (drob).",

  "import.type.dog.mleko.mlecnostKontrola": "Mleko - kontrola mlečnosti",
  "import.type.dog.mleko.mlecnostKontrola.description":
    "Uvoz podatkov kontrole mlečnosti.",

  "import.type.dog.mleko.molza": "Mleko - molža",
  "import.type.dog.mleko.molza.description": "Uvoz podatkov o molži.",

  "import.type.dog.odbira.odbira": "Odbira",
  "import.type.dog.odbira.odbira.description": "Uvoz podatkov odbire.",

  "import.type.dog.odstavitev.odstavitev": "Odstavitev",
  "import.type.dog.odstavitev.odstavitev.description":
    "Uvoz dogodkov odstavitve.",

  "import.type.dog.odstavitev.odstavitevPrasic": "Odstavitev (prašiči)",
  "import.type.dog.odstavitev.odstavitevPrasic.description":
    "Uvoz dogodkov odstavitve (prašiči).",

  "import.type.dog.oznacevanje.oznDrob": "Označevanje (drob)",
  "import.type.dog.oznacevanje.oznDrob.description":
    "Uvoz označevanj drobnice.",

  "import.type.dog.oznacevanje.oznPrasic": "Označevanje (prašiči)",
  "import.type.dog.oznacevanje.oznPrasic.description":
    "Uvoz označevanj prašičev.",

  "import.type.dog.prasic.mesnatost": "Mesnatost (prašiči)",
  "import.type.dog.prasic.mesnatost.description":
    "Uvoz meritev mesnatosti (prašiči).",

  "import.type.dog.prasic.preizkus": "Preizkus (prašiči)",
  "import.type.dog.prasic.preizkus.description":
    "Uvoz podatkov preizkusa (prašiči).",

  "import.type.dog.prasic.preizkus.meritev": "Preizkus (prašiči) - meritve",
  "import.type.dog.prasic.preizkus.meritev.description":
    "Uvoz meritev v okviru preizkusa (prašiči).",

  "import.type.dog.prasic.prodaja": "Prodaja (prašiči)",
  "import.type.dog.prasic.prodaja.description":
    "Uvoz podatkov prodaje (prašiči).",

  "import.type.dog.prasic.prodaja.prasic": "Prodaja (prašiči) - živali",
  "import.type.dog.prasic.prodaja.prasic.description":
    "Uvoz živali v prodaji (prašiči).",

  "import.type.dog.premik": "Premiki - uvoz prodaje",
  "import.type.dog.premik.description": "Uvoz prodaje (premiki).",

  "import.type.dog.pripusti.pripust": "Pripusti - pripust",
  "import.type.dog.pripusti.pripust.description": "Uvoz dogodkov pripusta.",

  "import.type.dog.seme.prepoved_prodaje": "Seme - prepoved prodaje",
  "import.type.dog.seme.prepoved_prodaje.description":
    "Uvoz evidenc prepovedi prodaje semena.",

  "import.type.dog.seme.vzorec": "Seme - vzorec",
  "import.type.dog.seme.vzorec.description": "Uvoz podatkov o vzorcih semena.",

  "import.type.dog.testna_postaja.krvnaAnaliza.analiza":
    "Testna postaja - krvna analiza: analiza",
  "import.type.dog.testna_postaja.krvnaAnaliza.analiza.description":
    "Uvoz analiz krvnih vzorcev.",

  "import.type.dog.testna_postaja.krvnaAnaliza.bolezen":
    "Testna postaja - krvna analiza: bolezen",
  "import.type.dog.testna_postaja.krvnaAnaliza.bolezen.description":
    "Uvoz bolezni/diagnoz za krvno analizo.",

  "import.type.dog.testna_postaja.krvnaAnaliza.rezultat":
    "Testna postaja - krvna analiza: rezultat",
  "import.type.dog.testna_postaja.krvnaAnaliza.rezultat.description":
    "Uvoz rezultatov krvne analize.",

  "import.type.dog.testna_postaja.naselitev": "Testna postaja - naselitev",
  "import.type.dog.testna_postaja.naselitev.description":
    "Uvoz naselitev v testno postajo.",

  "import.type.dog.testna_postaja.odkup.odkup": "Testna postaja - odkup",
  "import.type.dog.testna_postaja.odkup.odkup.description":
    "Uvoz podatkov odkupa.",

  "import.type.dog.testna_postaja.odkup.zival":
    "Testna postaja - odkup: živali (kombinirano)",
  "import.type.dog.testna_postaja.odkup.zival.description":
    "Uvoz živali v okviru odkupa (kombinirano).",

  "import.type.dog.testna_postaja.semeTp": "Testna postaja - seme",
  "import.type.dog.testna_postaja.semeTp.description":
    "Uvoz podatkov o semenu (TP).",

  "import.type.dog.testna_postaja.skupina": "Testna postaja - skupina",
  "import.type.dog.testna_postaja.skupina.description":
    "Uvoz skupin v testni postaji.",

  "import.type.dog.testna_postaja.spremniDokument":
    "Testna postaja - spremni dokument",
  "import.type.dog.testna_postaja.spremniDokument.description":
    "Uvoz spremnih dokumentov (TP).",

  "import.type.dog.testna_postaja.tehtanje": "Testna postaja - tehtanje",
  "import.type.dog.testna_postaja.tehtanje.description": "Uvoz tehtanj (TP).",

  "import.type.dog.testna_postaja.tretiranje": "Testna postaja - tretiranje",
  "import.type.dog.testna_postaja.tretiranje.description":
    "Uvoz tretiranj/posegov (TP).",

  "import.type.dog.vnos.vnosPoreklo": "Vnos - poreklo",
  "import.type.dog.vnos.vnosPoreklo.description":
    "Uvoz (UTF-8, ločilo ';'). Stolpci: usesnaStevilka; originalnaUsesnaStevilka; imeZivali; spol; datumRojstva; skupnaPlemenskaVrednost; pasmaSifra; opomba.",

  "import.type.dog.vnos.vnosUvozZivali": "Vnos - uvoz živali",
  "import.type.dog.vnos.vnosUvozZivali.description":
    "Uvoz podatkov uvoza živali.",

  "import.type.gen.geneologija": "Genealogija",
  "import.type.gen.geneologija.description": "Uvoz podatkov genealogije.",

  "import.type.gen.koefSorodstva": "Koeficient sorodstva",
  "import.type.gen.koefSorodstva.description":
    "Uvoz podatkov koeficientov sorodstva.",

  "import.type.rkg.gospodarstvo": "RKG - gospodarstvo",
  "import.type.rkg.gospodarstvo.description":
    "Uvoz podatkov gospodarstev (RKG).",

  "import.type.rkg.subjekt": "RKG - subjekt",
  "import.type.rkg.subjekt.description": "Uvoz podatkov subjektov (RKG).",

  "import.type.milkis.milkisImport": "Milkis",
  "import.type.milkis.milkisImport.description": "Uvoz rezultatov mlečnosti",

  "import.type.dog.vnos.vnosUvozZivali.upload_uvoz": "Vnos živali - uvoz",
  "import.type.dog.vnos.vnosUvozZivali.upload_uvoz.description":
    "Uvoz podatkov o živali - uvoz",

  "import.type.dog.vnos.vnosUvozZivali.upload_seme": "Vnos živali - seme",
  "import.type.dog.vnos.vnosUvozZivali.upload_seme.description":
    "Uvoz podatkov o živali - seme",

  "import.type.dog.vnos.vnosUvozZivali.upload_izven_kontrole":
    "Vnos živali - izven kontrole",
  "import.type.dog.vnos.vnosUvozZivali.upload_izven_kontrole.description":
    "Uvoz podatkov o živali - izven kontrole",

  "import.type.dog.oznacevanje.oznDrob.upload_jagnjitev_oznacitev":
    "Jagnjitev in označitev mladičev",
  "import.type.dog.oznacevanje.oznDrob.upload_jagnjitev_oznacitev.description":
    "Uvoz podatkov o jagnjitvi in označitvi",

  "import.type.dog.testna_postaja.semeTp.upload_combined": "Seme",
  "import.type.dog.testna_postaja.semeTp.upload_combined.description":
    "Uvoz podatkov o semu",
};
